import styled from 'styled-components'
import theme from '../../styles/theme'
import BGImageURL from '../../images/clubTercera_BG.jpg'

const ClubWrapper = styled.div`
  text-align: center;
  line-height: 1.1;
  max-width: 600px;

  .body {
    padding: 1rem;
    background-color: white;
    .logo {
      max-width: 300px;
      margin-left: auto;
      margin-right: auto;
    }
    h2 {
      line-height: 0.8;
    }

    .scroller {
      margin-left: -1rem;
      margin-right: -1rem;
    }
  }

  .sep {
    display: inline-block;
    width: 0.6em;
    height: 0.6em;
    background-color: black;
    border-radius: 1em;
    margin-bottom: 2px;
    margin-left: 4px;
    margin-right: 4px;
  }
`

const Container = styled.section`
  position: relative;
  overflow: hidden;
  height: auto;
  max-width: ${theme.overWidth};
  margin-left: auto;
  margin-right: auto;
  display: flex;
  background-image: url(${BGImageURL});
  background-size: 60%;
  background-repeat: repeat;
`

const Content = styled.div`
  position: relative;
  max-width: 100vw;
  display: flex;
  height: 100%;
  flex: column;
  /* margin-left: 7vw; */
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  flex-direction: column;
`

const TextHolder = styled.div`
  color: white;
  display: block;
  width: 50%;
  /* text-transform: uppercase; */
`
export { Container, Content, TextHolder, ClubWrapper }
